const plainSortObject = (objectValue) => Object.fromEntries(
  Object.entries(objectValue).sort(([keyA], [keyB]) => {
    if (keyA < keyB) {
      return -1;
    }
    if (keyA > keyB) {
      return 1;
    }
    return 0;
  })
);
export {
  plainSortObject
};
//# sourceMappingURL=plainSortObject.js.map